import Text from 'components/Text/Text';
import React, { useContext } from 'react';
import {
	IRestaurantFullInfoContext,
	RestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';
import style from './RestaurantManagerField.module.scss';

const RestaurantManagerField = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	return (
		<div className={style.container}>
			<Text translationNameSpace="form" translationKey="restaurantManagersLabel" theme="neutralLight" size="xs" />
			<div className={style.restaurantManagersList}>
				{restaurantForFullInfo?.restaurantManagers.length ? (
					restaurantForFullInfo.restaurantManagers.map((el) => {
						return (
							<div key={el.userId} className={style.item}>
								<div className={style.dot} />
								<Text translationKey={el.firstName} asFragment={true} />
							</div>
						);
					})
				) : (
					<Text translationNameSpace="form" translationKey="-" />
				)}
			</div>
		</div>
	);
};

export default RestaurantManagerField;
